// GENERATED by Maeve's work/meetings_page/gen_content.py (Sep 29 2026): edit the generator, not this file.
// ONE source for /ai-employees/meetings: MeetingsLandingPage.js, its JSON-LD, and the .md alternate
// (scripts/copyMarketingTwins.js). Comparison cells = each company's OWN docs re-read Oct 1 2026; rule
// (Nitish): not mentioned in their docs = not available; re-read every 30 days (Maeve, CEL-3125).
// Our column rests on md/cellcog/customer_support/CellCog_Meetings_Guide.md; the calls content on
// CellCog_Phone_Guide.md (Sep 30 2026).
export const MEETINGS = {
 "path": "/ai-employees/meetings",
 "ogImage": "/assets/meetings/meetings-og.jpg",
 "seo": {
  "title": "AI Meeting Assistant That Also Takes Your Calls | CellCog",
  "description": "An AI meeting assistant that joins Google Meet, Zoom and Microsoft Teams, answers calls on their own number, places calls, and does the follow-up work after."
 },
 "hero": {
  "eyebrow": "Meetings and calls",
  "h1": "AI employees for your meetings and calls.",
  "accent": "meetings and calls.",
  "sub": "Your AI meeting assistant that also takes your calls. Bring them to Google Meet, Zoom or Microsoft Teams, talk it through in the chat, or give them their own phone number."
 },
 "films": [
  {
   "key": "hire",
   "n": "01",
   "tag": "The hire",
   "title": "Alex hires Nora.",
   "line": "One line, and she starts the same day.",
   "duration": "1:32",
   "iso": "PT1M32S",
   "uploadDate": "2026-09-25T00:00:00-04:00",
   "burned": true,
   "schemaName": "Alex hires Nora, an AI marketing manager",
   "description": "Alex runs a design studio. He hires Nora, an AI marketing manager, with one line, and she takes on the studio's marketing the same day.",
   "transcript": [
    [
     "",
     "Alex started a design studio to design."
    ],
    [
     "",
     "Not to spend every evening being the marketing department,"
    ],
    [
     "",
     "the ads department, the follow-up with that lead from March department."
    ],
    [
     "",
     "So Alex hired one."
    ],
    [
     "",
     "He typed what he needed."
    ],
    [
     "",
     "That was the whole interview."
    ],
    [
     "",
     "She introduced herself."
    ],
    [
     "",
     "He gave her the tools, the context, the access."
    ],
    [
     "",
     "By lunch, she was running."
    ],
    [
     "",
     "While Alex pitched a client, Nora shipped the week's campaign."
    ],
    [
     "",
     "While he took a coffee break, she answered a lead."
    ],
    [
     "",
     "He approved it between sips."
    ],
    [
     "",
     "He decides, and Nora runs."
    ],
    [
     "",
     "While he slept, she prepped the numbers."
    ],
    [
     "",
     "Mornings start with answers now."
    ],
    [
     "",
     "Nine to five or Saturday morning."
    ],
    [
     "",
     "Nora works whenever there's work."
    ],
    [
     "",
     "The studio didn't get louder, it just got lighter."
    ],
    [
     "",
     "Alex designs, the marketing happens."
    ],
    [
     "",
     "And when Friday needed a designer, he hired one after breakfast."
    ],
    [
     "",
     "Just for the day."
    ],
    [
     "",
     "Hire your first AI employee at cellcog.ai."
    ]
   ],
   "src": "/assets/meetings/meetings-hire.mp4",
   "poster": "/assets/meetings/meetings-hire-poster.jpg",
   "vtt": "/assets/meetings/meetings-hire.vtt"
  },
  {
   "key": "brainstorm",
   "n": "02",
   "tag": "The plan",
   "title": "They think it through, out loud.",
   "line": "Alex presses Meet. Nora already has a plan.",
   "duration": "0:47",
   "iso": "PT47S",
   "uploadDate": "2026-09-26T00:00:00-04:00",
   "burned": false,
   "schemaName": "Thinking a client's timeline through with an AI employee",
   "description": "Alex presses Meet in the chat and talks a client's timeline through with Nora, out loud. She proposes phasing the work and drafts the plan for his approval.",
   "transcript": [
    [
     "Alex",
     "Nora, got a minute? The Harbor Office thing."
    ],
    [
     "Nora",
     "Yeah. Their reply came in this morning."
    ],
    [
     "Nora",
     "They loved the concept, but they're nervous about the timeline."
    ],
    [
     "Alex",
     "Mm. Nervous how?"
    ],
    [
     "Nora",
     "Their team moves in November. If we..."
    ],
    [
     "Alex",
     "...miss that, they're working out of boxes."
    ],
    [
     "Nora",
     "Exactly. So what if we phase it?"
    ],
    [
     "Nora",
     "Quiet room first, the rest after they move in."
    ],
    [
     "Alex",
     "[laughs] You've been waiting to say that."
    ],
    [
     "Nora",
     "Since this morning, honestly."
    ],
    [
     "Alex",
     "Okay. Phase one by November. Can you write it up?"
    ],
    [
     "Nora",
     "Drafting it now. It'll be waiting for your approval."
    ],
    [
     "Alex",
     "Perfect. Thanks, Nora."
    ]
   ],
   "src": "/assets/meetings/meetings-brainstorm.mp4",
   "poster": "/assets/meetings/meetings-brainstorm-poster.jpg",
   "vtt": "/assets/meetings/meetings-brainstorm.vtt"
  },
  {
   "key": "client_call",
   "n": "03",
   "tag": "The client call",
   "title": "Nora joins the client call.",
   "line": "She answers Marcus and brings in Tia.",
   "duration": "1:32",
   "iso": "PT1M32S",
   "uploadDate": "2026-09-26T00:00:00-04:00",
   "burned": false,
   "schemaName": "An AI employee on a client call",
   "description": "Nora joins Alex's call with his client Marcus, answers the timeline question from her notes, and brings in Tia, the AI designer, to walk through the layout.",
   "transcript": [
    [
     "Marcus",
     "Thanks for making time. We loved the phased idea."
    ],
    [
     "Alex",
     "Glad to hear it. Nora's with us too."
    ],
    [
     "Nora",
     "Hi Marcus. Good to talk again."
    ],
    [
     "Marcus",
     "So, the timeline."
    ],
    [
     "Marcus",
     "Can the quiet room be ready before we move in?"
    ],
    [
     "Nora",
     "You said November fourteenth on our first call. Phase one is done by the seventh."
    ],
    [
     "Marcus",
     "Oh, good. And how will it actually feel? My team takes a lot of calls in there."
    ],
    [
     "Nora",
     "Tia worked on the latest layout. Let me message her to join."
    ],
    [
     "Tia",
     "Hi everyone."
    ],
    [
     "Nora",
     "Hi Tia. Marcus wants to know how the quiet room will feel."
    ],
    [
     "Nora",
     "His team takes a lot of calls in there."
    ],
    [
     "Tia",
     "Right. Marcus, it's on the north wall, so it gets soft light all afternoon."
    ],
    [
     "Tia",
     "And oak slats on the walls to soak up the sound."
    ],
    [
     "Nora",
     "The same oak as the lobby, Tia? They loved that."
    ],
    [
     "Tia",
     "Same oak. It'll feel like one space."
    ],
    [
     "Marcus",
     "That's exactly what I pictured."
    ],
    [
     "Alex",
     "[laughs] You two are the best. Thank you."
    ],
    [
     "Tia",
     "Anything else you'd like to go over, Marcus?"
    ],
    [
     "Marcus",
     "No, that covers it."
    ],
    [
     "Nora",
     "I'll send today's notes this afternoon, with Tia's layout options."
    ],
    [
     "Marcus",
     "Perfect. Thanks, all."
    ],
    [
     "Alex",
     "Sounds great."
    ]
   ],
   "src": "/assets/meetings/meetings-client_call.mp4",
   "poster": "/assets/meetings/meetings-client_call-poster.jpg",
   "vtt": "/assets/meetings/meetings-client_call.vtt"
  }
 ],
 "afterFilms": "Hire yours in one line. Then invite them to your next call.",
 "ways": {
  "eyebrow": "Meetings and calls",
  "title": "Four ways to talk to them.",
  "items": [
   {
    "key": "chat",
    "title": "In the chat",
    "body": "Press Meet and think it through out loud, from your laptop or your phone."
   },
   {
    "key": "meet",
    "title": "Google Meet, Zoom and Microsoft Teams",
    "body": "Invite them by email. They join under their own name, speak up, and send the notes after."
   },
   {
    "key": "phone",
    "title": "Their own phone number",
    "body": "People call them and they answer in seconds. You can call them from your phone too."
   },
   {
    "key": "calls",
    "title": "They make the call",
    "body": "Interviews, callbacks, customers who asked to hear back. Never a cold call."
   }
  ]
 },
 "phone": {
  "eyebrow": "Their own phone number",
  "title": "An AI phone agent that answers your calls, and makes them.",
  "lead": "A local number in 50+ countries. They pick up in seconds, and call back the people who asked them to.",
  "phones": [
   {
    "key": "in",
    "status": "Incoming call",
    "initials": "",
    "name": "New inquiry",
    "sub": "New York",
    "pill": "Nora is answering",
    "caption": "People call them",
    "alt": "A phone showing an incoming call from a new inquiry in New York, answered by Nora, the AI employee."
   },
   {
    "key": "out",
    "status": "Nora is calling",
    "initials": "M",
    "name": "Marcus",
    "sub": "Harbor Office",
    "pill": "Answered · 1:46",
    "caption": "They call for you",
    "alt": "A phone showing Nora, the AI employee, calling Marcus at Harbor Office about phase one. He answered."
   }
  ]
 },
 "steps": {
  "eyebrow": "How it works",
  "title": "One meeting, start to finish.",
  "items": [
   "Invite them like anyone else.",
   "They join under their own name, camera off.",
   "They answer, or say they will come back to you.",
   "You get the notes and the to-dos."
  ]
 },
 "trust": {
  "title": "They speak for themselves, never for you.",
  "rows": [
   {
    "title": "Answers from their own work",
    "body": "Their tasks, email and notes."
   },
   {
    "title": "Defers what is yours",
    "body": "Prices, dates, scope."
   },
   {
    "title": "Keeps a record",
    "body": "Preparation, transcript, notes."
   }
  ]
 },
 "compare": {
  "eyebrow": "Compared",
  "title": [
   "Plenty of AI can sit in on a call.",
   "Yours also answers the phone, and knows what not to promise."
  ],
  "cols": [
   {
    "key": "cellcog",
    "name": "CellCog",
    "logo": "/apple-touch-icon.png",
    "source": null
   },
   {
    "key": "spinnable",
    "name": "Spinnable",
    "logo": "/assets/meetings/logos/spinnable.png",
    "source": "https://docs.spinnable.ai/release-notes/september-2026-monthly-update",
    "more": [
     {
      "label": "prep",
      "source": "https://docs.spinnable.ai/onboarding-plans/ea-calendar-management"
     }
    ]
   },
   {
    "key": "grok",
    "name": "Grok Bot",
    "logo": "/assets/meetings/logos/grok.png",
    "source": "https://x.ai/news/grok-bot-more-plans"
   },
   {
    "key": "lindy",
    "name": "Lindy",
    "logo": "/assets/meetings/logos/lindy.png",
    "source": "https://docs.lindy.ai/teammate/meeting-library",
    "more": [
     {
      "label": "prep",
      "source": "https://docs.lindy.ai/features/meeting-assistant/meeting-prep"
     }
    ]
   },
   {
    "key": "sintra",
    "name": "Sintra",
    "logo": "/assets/meetings/logos/sintra.png",
    "source": "https://help.sintra.ai/en/articles/12899745-meeting-notetaker",
    "more": [
     {
      "label": "video",
      "source": "https://sintra.ai/summer-edition"
     }
    ]
   },
   {
    "key": "viktor",
    "name": "Viktor",
    "logo": "/assets/meetings/logos/viktor.png",
    "source": "https://viktor.com/integrations/zoom",
    "more": [
     {
      "label": "files",
      "source": "https://getviktor.com/blog/viktor-vs-claude-in-slack"
     }
    ]
   }
  ],
  "rows": [
   {
    "label": "Joins and speaks in your call",
    "values": [
     1,
     1,
     0,
     0,
     0,
     0
    ]
   },
   {
    "label": "Prepares before the call",
    "values": [
     1,
     1,
     0,
     1,
     0,
     0
    ]
   },
   {
    "label": "Takes notes, then does the follow-up",
    "values": [
     1,
     1,
     0,
     1,
     0,
     0
    ]
   },
   {
    "label": "Never promises dates or prices for you",
    "values": [
     1,
     0,
     0,
     0,
     0,
     0
    ]
   },
   {
    "label": "Answers your customers’ calls",
    "values": [
     1,
     0,
     0,
     0,
     0,
     0
    ]
   },
   {
    "label": "Calls people back for you",
    "values": [
     1,
     0,
     0,
     0,
     0,
     0
    ]
   },
   {
    "label": "Makes video, audio and images for you",
    "values": [
     1,
     0,
     0,
     0,
     1,
     0
    ]
   }
  ],
  "note": "✕ = not mentioned in the company’s own documentation, October 2026. Product names and logos belong to their owners and are used only to identify the products compared. No affiliation or endorsement.",
  "noteMd": "“Not in their docs” = not mentioned in the company’s own documentation, October 2026. Product names and logos belong to their owners and are used only to identify the products compared. No affiliation or endorsement."
 },
 "faqTitle": "AI employees in meetings, answered",
 "faq": [
  {
   "q": "Which meeting apps can an AI employee join?",
   "a": "Google Meet, Zoom and Microsoft Teams. You invite them the same way you invite a person: add their email address to the calendar invite."
  },
  {
   "q": "Is this an AI meeting assistant?",
   "a": "Yes, and more. Like an AI meeting assistant they join Google Meet, Zoom and Microsoft Teams and send the notes, but they also speak in the meeting, answer from their own work, and do their share of the follow-up. They take your calls on their own number too."
  },
  {
   "q": "Do they show up on camera?",
   "a": "No. Your AI employee joins with the camera off, under their own name, marked as AI, so everyone knows who they are talking to."
  },
  {
   "q": "What will they say, and what won’t they?",
   "a": "They answer questions about their own work, from their tasks, emails and notes. Anything that commits you, such as a price, a date or a change in scope, they defer: they tell the room they will come back after the call, and bring the question to you."
  },
  {
   "q": "What happens after the call?",
   "a": "They send you the notes, the transcript and what needs you, in their chat, and start on their share of the to-dos."
  },
  {
   "q": "Can I talk to them without scheduling a call?",
   "a": "Yes. Press Meet in any chat with your AI employee and talk it through out loud. The notes land in the same chat."
  },
  {
   "q": "Can an AI employee have their own phone number?",
   "a": "Yes. Ask them in chat and they offer you local numbers, in the US or in 50+ other countries. People who call that number talk to your AI employee, who can hand a call to you, and every call has a transcript and its notes."
  },
  {
   "q": "Can they call people for me?",
   "a": "Yes, people who expect the call: an applicant, a customer, someone who asked to be called back. Your AI employee never cold calls. You verify your business once, and every call goes out under your business name."
  },
  {
   "q": "Does your AI employee tell callers they are talking to an AI?",
   "a": "Yes. Every call, in or out, opens with the fact that they are talking with an AI employee at your company. Your AI employee never commits you to a price or a date on a call."
  },
  {
   "q": "How is this different from an AI note taker?",
   "a": "A note taker listens and writes a summary, usually in a private side panel. An AI employee speaks in the meeting, answers from the work they have done, and then does their part of what was decided."
  }
 ],
 "close": {
  "title": "Bring your AI employee to the next call.",
  "sub": "Hire one, send them the invite, and read their notes when the call ends."
 }
};

export default MEETINGS;
